import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';
import { StoreService } from '../../../stores/services/store.service';
import { AuthService } from '../../services/auth.service';

/**
 * Landing page for the TikTok Shop authorization redirect
 * (<cornerstone-ui>/tiktok/verify?code=...&state=<storeUuid>). Posts the code
 * and state to the API, which exchanges the code for tokens.
 */
@Component({
  selector: 'app-tiktok-auth-verify',
  // Same layout as the Shopify verify page.
  templateUrl:
    '../shopify-auth-verify/shopify-auth-verify.component.html',
  styleUrls: ['../shopify-auth-verify/shopify-auth-verify.component.scss'],
})
export class TikTokAuthVerifyComponent implements OnInit {
  public verifiedStatus: 'pending' | 'verified' | 'error' = 'pending';
  public title: string = 'Store verification';
  public description: string = 'Linking your TikTok Shop, please wait...';
  public src: string = '../../../assets/media/illustrations/sigma-1/17.png';

  constructor(
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private storeService: StoreService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.activeRoute.queryParams.pipe(take(1)).subscribe((params) => {
      const { code, state } = params;
      if (!code || !state) {
        this.showError(
          'TikTok did not return an authorization code. The authorization may have been cancelled; contact the administrator for a new link.'
        );
        return;
      }
      this.verify(code, state);
    });
  }

  private verify(code: string, state: string) {
    this.authService.tiktokAuthVerify({ code, state }).subscribe({
      next: (store) => {
        this.storeService.notifyStore(store);
        this.title = 'Verified Store';
        this.description =
          'Your TikTok Shop was successfully linked, you can now close this window.';
        this.verifiedStatus = 'verified';
        this.src = '../../../assets/media/illustrations/sigma-1/8.png';
        this.cdr.detectChanges();
        setTimeout(() => {
          try {
            window.close();
          } catch {}
        }, 2000);
      },
      error: () =>
        this.showError(
          'Could not link the TikTok Shop. The authorization code may have expired or already been used; contact the administrator for a new link.'
        ),
    });
  }

  private showError(description: string) {
    this.verifiedStatus = 'error';
    this.title = 'Oops sorry, verification failed';
    this.description = description;
    this.src = '../../../assets/media/illustrations/sigma-1/21.png';
    this.cdr.detectChanges();
  }

  public close() {
    window.close();
  }
}
